import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { fetchNews } from "@/lib/api";
import { NewsCard } from "@/components/NewsCard";
import { useLang } from "@/i18n";
import { Loader2, SearchIcon } from "lucide-react";

export default function Search() {
  const [sp] = useSearchParams();
  const q = sp.get("q") || "";
  const { lang, t } = useLang();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchNews({ lang, search: q, limit: 60 })
      .then((res) => { if (!cancelled) setItems(res); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [q, lang]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="search-page">
      <div className="border-b-2 border-white pb-4 mb-10">
        <span className="eyebrow text-red-500">{t("search_results")}</span>
        <h1 className="headline text-4xl sm:text-5xl mt-2 flex items-center gap-3 text-white" data-testid="search-query">
          &ldquo;{q}&rdquo;
        </h1>
        <p className="mt-2 text-sm font-mono text-neutral-500">{items.length} {lang === "tr" ? "sonuç" : "results"}</p>
      </div>

      {loading ? (
        <div className="py-24 flex items-center justify-center">
          <Loader2 className="animate-spin text-red-600" size={32} />
        </div>
      ) : items.length === 0 ? (
        <div className="py-24 text-center text-neutral-500" data-testid="search-no-results">
          <p className="text-lg">{t("no_results")}</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-10">
          {items.map((item) => (
            <NewsCard key={item.id} item={item} />
          ))}
        </div>
      )}
    </div>
  );
}
